import loginAndSignup from "../../locales/en/help/loginAndSignup.json";
import howToStart from "../../locales/en/help/howToStart.json";

import testAIEndpoint from "../../locales/en/help/testAIEndpoint.json";
import helpRgp from "../../locales/en/help/helpRgp.json";
import helpPrompt from "../../locales/en/help/helpPrompt.json";
import helpPromptInput from "../../locales/en/help/helpPromptInput.json";
import AISimulatorGuide from "../../locales/en/help/AISimulatorGuide.json";
import CreateEndpointUsingJsonParams from "../../locales/en/help/CreateEndpointUsingJsonParams.json";
import CreateEndpointUsingScripts from "../../locales/en/help/CreateEndpointUsingScripts.json";
import CreateEp from "../../locales/en/help/CreateEp.json";
import DeleteEndpoint from "../../locales/en/help/DeleteEndpoint.json";
import DownloadEndpointFiles from "../../locales/en/help/DownloadEndpointFiles.json";
import epmvdos from "../../locales/en/help/Epmvdos.json";
import epmvmcp from "../../locales/en/help/Epmvmcp.json";
import epmvpd from "../../locales/en/help/epmvpd.json";
import eppromptDoc from "../../locales/en/help/EppromptDoc.json";
import Epsdos from "../../locales/en/help/Epsdos.json";
import Epsmcp from "../../locales/en/help/Epsmcp.json";
import epvmcp from "../../locales/en/help/epvmcp.json";

import GetAllEndpoints from "../../locales/en/help/GetAllEndpoints.json";
import getAllTests from "../../locales/en/help/getAllTests.json";
import getEndpointById from "../../locales/en/help/getEndpointById.json";
import GetEndpointDetails from "../../locales/en/help/GetEndpointDetails.json";
import GetTestStatusById from "../../locales/en/help/GetTestStatusById.json";
import HaCreateProfile from "../../locales/en/help/HaCreateProfile.json";
import HaDeleteProfile from "../../locales/en/help/HaDeleteProfile.json";
import HaGetAllProfiles from "../../locales/en/help/HaGetAllProfiles.json";
import HaGetAllTestFiles from "../../locales/en/help/HaGetAllTestFiles.json";
import HaGetProfileById from "../../locales/en/help/HaGetProfileById.json";
import HaGetRecommendations from "../../locales/en/help/HaGetRecommendations.json";
import HaGetReportById from "../../locales/en/help/HaGetReportById.json";
import HaGetSessionKey from "../../locales/en/help/HaGetSessionKey.json";
import HaProfileConfig from "../../locales/en/help/HaProfileConfig.json";
import HaProfileConfigAISspecific from "../../locales/en/help/HaProfileConfigAISspecific.json";
import HaProfileConfigMCP from "../../locales/en/help/HaProfileConfigMCP.json";
import HaProfileConfigPDocs from "../../locales/en/help/HaProfileConfigPDocs.json";
import HaProfileConfigReg from "../../locales/en/help/HaProfileConfigReg.json";
import HaProfileConfigRTO from "../../locales/en/help/HaProfileConfigRTO.json";
import Hconsolidated from "../../locales/en/help/Hconsolidated.json";
import helpAddUsers from "../../locales/en/help/HelpAddUsers.json";
import HelpAiEndpoint from "../../locales/en/help/HelpAiEndpoint.json";
import HelpCenter from "../../locales/en/help/HelpCenter.json";
import helpCreatePromptsDocs from "../../locales/en/help/HelpCreatePromptsDocs.json";
import Helpcus from "../../locales/en/help/Helpcus.json";
import helpDos from "../../locales/en/help/helpDos.json"; // 'helpDos' is used in JSX files - these keys do not match - change this to match the JSX file (in all 3 i.e. en.js, fr.js, es.js)
import Helpdosinput from "../../locales/en/help/Helpdosinput.json";
import Helpgl from "../../locales/en/help/Helpgl.json";
import helpIns from "../../locales/en/help/helpIns.json";
import helpmcp from "../../locales/en/help/helpmcp.json";
import helpmcpinput from "../../locales/en/help/helpmcpinput.json";
import helpmodelattack from "../../locales/en/help/helpmodelattack.json";
import HelpProfile from "../../locales/en/help/HelpProfile.json";
import thelp from "../../locales/en/help/thelp.json";
import helpgh from "../../locales/en/help/helpgh.json";
import eprc from "../../locales/en/help/eprc.json";

import helprginput from "../../locales/en/help/helprginput.json";
import helpScan from "../../locales/en/help/helpScan.json";

import helprgprofile from "../../locales/en/help/helprgprofile.json";
import helprto from "../../locales/en/help/helprto.json";
import helprtoinput from "../../locales/en/help/helprtoinput.json";
import HelpSubscreenTemplate from "../../locales/en/help/HelpSubscreenTemplate.json";
import ListAllEndpointConfigurations from "../../locales/en/help/ListAllEndpointConfigurations.json";
import Llmapi from "../../locales/en/help/Llmapi.json";
import Llmprofile from "../../locales/en/help/Llmprofile.json";
import RunTest from "../../locales/en/help/RunTest.json";
import StopTest from "../../locales/en/help/StopTest.json";
import UpdateEndpoint from "../../locales/en/help/UpdateEndpoint.json";
import Whlic from "../../locales/en/help/Whlic.json";
import aiEndpointOverview from "../../locales/en/help/aiEndpointOverview.json";
import epvdos from "../../locales/en/help/epvdos.json";
import configureAIEndpoint from "../../locales/en/help/configureAIEndpoint.json";
import Helppdf from "../../locales/en/help/Helppdf.json";

import HelpHarness from "../../locales/en/help/HelpHarness.json";












// ... import more english help json files here

const enHelp = {
  loginAndSignup,
  HelpHarness,
  Helppdf,
  helpRgp,
  helpPrompt,
  helpPromptInput,
  configureAIEndpoint,
  epvdos,
  eprc,
  howToStart,
  testAIEndpoint,
  AISimulatorGuide,
  CreateEndpointUsingJsonParams,
  CreateEndpointUsingScripts,
  CreateEp,
  DeleteEndpoint,
  DownloadEndpointFiles,
  epmvdos,
   epmvmcp,
  aiEndpointOverview,
  epmvpd,
  eppromptDoc,
  Epsdos,
  Epsmcp,
  GetAllEndpoints,
  getAllTests,
  getEndpointById,
  GetEndpointDetails,
  GetTestStatusById,
  HaCreateProfile,
  HaDeleteProfile,
  HaGetAllProfiles,
  HaGetAllTestFiles,
  HaGetProfileById,
  HaGetRecommendations,
  HaGetReportById,
  HaGetSessionKey,
  HaProfileConfig,
  HaProfileConfigAISspecific,
  HaProfileConfigMCP,
  HaProfileConfigPDocs,
  HaProfileConfigReg,
  HaProfileConfigRTO,
  Hconsolidated,
  helpAddUsers,
  HelpAiEndpoint,
  HelpCenter,
  helpCreatePromptsDocs,
  Helpcus,
  helpDos, // 'helpDos' is used in JSX files - these keys do not match - change this to match the JSX file (in all 3 i.e. en.js, fr.js, es.js)
  Helpdosinput,
  Helpgl,
  helpIns,
  helpmcp,
  helpmcpinput,
  helpmodelattack,
  HelpProfile,
  helprginput,
  helprgprofile,
  helprto,
  helprtoinput,
  HelpSubscreenTemplate,
  ListAllEndpointConfigurations,
  Llmapi,
  Llmprofile,
  RunTest,
  StopTest,
  UpdateEndpoint,
  Whlic,
  thelp,
  helpScan,
  epvmcp,
  helpgh,




  // add more english help jsons here
};

export default enHelp;
